import { CommonContractorCreateUpdateApp } from '../../../../Dashboard/Contractors/Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp';
import routes from '../../../../../Routes/routes';
import HeadTittle from '../../../../../components/HeadTittle';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { EditIcon } from '../../../../../components/buttons/IconButtons';
import React from 'react';
import { SupplierFlowEmployeeUpdateApp } from '../../Funtionality/SupplierCreateUpdateFlows/SupplierFlowEmployeeUpdateApp';
import CopySecretModal from '../../../../Dashboard/Company/Employees/Modal/CopySecretModal';
import { validateMinLengthTrimmed } from '../../../../../Apis/functions';
import { PASSWORD_MIN_LENGTH } from '../../../../../constant/variable';
import UnlinkDeviceBtn from '../../../../../components/buttons/UnlinkDeviceBtn';
import SupplierFlowEmployeeUpdateWithDetails from './SupplierFlowEmployeeUpdateWithDetails';
import SupplierFlowEmployeeUpdateWithoutDetails from './SupplierFlowEmployeeUpdateWithoutDetails';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const SupplierFlowEmployeeUpdate = () => {
    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        supplierId,
        params,
        permission,
        dispatch,
        setEmptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        setIsValidDocumentId,
        userInfoStatusList,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        photoPicker,
        setPhotoPicker,
        handleDateChange,
        handleEmailChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        isValidPassword,
        setIsValidPassword,
        handlePasswordChange,
        extraData,
        extraDataEnabled,
        setExtraData,
        setExtraDataEnabled,
        headersList,
    } = props;

    const {
        emptyFields,
        user,
        setUser,
        FormHandler,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        showUnlinkBtn,
        setModified,
        handleChange,
    } = SupplierFlowEmployeeUpdateApp({
        t,
        permission,
        dispatch,
        setEmptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidPassword,
        isValidDob,
        supplierId,
        params,
        photoPicker,
        setPhotoPicker,
        setSecretModal,
        setSecretKey,
        extraData,
        extraDataEnabled,
        setExtraData,
        setExtraDataEnabled,
        headersList,
    });

    return (
        <>
            <HeadTittle link={routes.suppliers.employees} name={t('update')}>
                <ButtonAction
                    id={'btn_sfeu_create'}
                    name={'update'}
                    className={'btn-icon-edit'}
                    disabled={false}
                    Icon={EditIcon}
                    onClick={() => {
                        validateEmail(user.email);
                        validatePhone(user.phoneNumber);
                        const isValid = validateMinLengthTrimmed(user.password, {
                            minLength: PASSWORD_MIN_LENGTH,
                            allowEmpty: true,
                        });
                        setIsValidPassword(isValid);

                        if (!isValid) return;
                        FormHandler();
                    }}
                />
                {showUnlinkBtn && <UnlinkDeviceBtn userId={user.userId} updated={() => setModified(true)} />}
            </HeadTittle>
            {extraDataEnabled ? (
                <SupplierFlowEmployeeUpdateWithDetails
                    user={user}
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    emptyFields={emptyFields}
                    setUser={setUser}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    userInfoStatusList={userInfoStatusList}
                    handlePasswordChange={handlePasswordChange}
                    extraData={extraData}
                    setExtraData={setExtraData}
                    handleChange={handleChange}
                    headersList={headersList}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                />
            ) : (
                <SupplierFlowEmployeeUpdateWithoutDetails
                    user={user}
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    emptyFields={emptyFields}
                    setUser={setUser}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    userInfoStatusList={userInfoStatusList}
                    handlePasswordChange={handlePasswordChange}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                />
            )}
            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                onHide={() => {}}
                closeText={'close'}
            />
        </>
    );
};
export default SupplierFlowEmployeeUpdate;
